import React from "react";
import { EmailLogin } from "../../api/auth.service";
import { type View } from "./AuthModal";
import { Button } from "../ui/button";
import useLoading from "../../hooks/useLoading";
import { SvgArrowLeft, SvgWarning } from "../icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useToast } from "../../hooks/useToast";
interface Props {
    isModalVariant?: boolean;
    setView: React.Dispatch<React.SetStateAction<View>>
}

export default function ForgotPassword({ isModalVariant, setView }: Props) {
    const [values, setValues] = React.useState<any>({
        email: "",
    });
    const [formErrors, setFormErrors] = React.useState<any>({});
    const [isSubmit, setIsSubmit] = React.useState<boolean>(false);
    const location = useLocation()
    const navigate = useNavigate();
    const { startLoading, stopLoading } = useLoading();
    const { toast } = useToast()
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let target = e.target as HTMLInputElement;
        setValues({ ...values, [target.name]: target.value });
    };

    const validateForm = (values: any) => {
        const errors: any = {};
        var mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;
        const match = values.email.match(mailformat);
        (!values.email || !match) && (errors.email = "Valid email is required");
        return errors;
    };

    React.useEffect(() => {
        if (isSubmit && Object.keys(formErrors).length === 0) {
            startLoading();
            setIsSubmit(false);
            const pathname = location.pathname
            EmailLogin.resetPasswordSendLink({ email: values.email, pathname: pathname })
                .then((data) => {
                    if (data.message === "complete") {
                        stopLoading();
                        navigate("/?reset=true");
                        setTimeout(() => navigate(pathname), 0)
                    } else {
                        stopLoading();
                    }
                })
                .catch((ex) => {
                    console.error(ex);
                    toast.error(ex.response.data.message);
                    stopLoading();
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formErrors]);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setFormErrors(validateForm(values));
        setIsSubmit(true);
    };

    const handleBackToSignInClick = () => {
        setView("email")
    };

    return (
        <div className={`${isModalVariant ? "" : "pb-[200px] mt-[190px]"} flex items-center flex-col justify-start`}>
            <div className="font-semibold text-[28px] mb-[24px]">Forgot Password?</div>
            <div className="text-center w-[260px] text-graySlate text-base mb-[40px]">
                To reset your password, enter your login email and we`ll send you instructions
            </div>
            <form action="#" onSubmit={handleSubmit} className="flex flex-col items-center">
                <div className="mb-[24px]">
                    <div className={`default-input ${formErrors.email && "input-error"}`}>
                        <input
                            type="text"
                            placeholder="Email"
                            onChange={handleChange}
                            name="email"
                            autoComplete="off"
                        />
                        <div className="overlay">Email</div>
                    </div>
                    {formErrors.email && (
                        <div className="field-error">
                            <SvgWarning />
                            {formErrors.email}
                        </div>
                    )}
                </div>
                <Button size="lg" type="submit">Send Instructions</Button>
            </form>

            <Button
                onClick={handleBackToSignInClick}
                className="mt-[50px]"
                variant="ghost"
            >
                <SvgArrowLeft className="back-arrow" />
                Sign In
            </Button>
        </div>
    );
};
